import RemoteForm from './remoteFormPanel.mjs';
import { I18n } from '../helpers/i18n.mjs';
import FormanConfig from '../formanConfig.mjs';

const config = FormanConfig.config.fields.account;

export default class ConnectionManager extends EventTarget {
	static async getCreateConnectionPanel(instructions, target, personalConnections, metadata = {}, parentForm = null) {
		// celonis
		const onlyPersonal = !instructions?.options?.team && instructions.accountInputPanel && personalConnections;
		const panel = new RemoteForm(target, parentForm);
		const instructionsQuery = new URLSearchParams();

		instructions.connectionTypes.forEach((acc) => instructionsQuery.append('type', acc.type));

		if (personalConnections) {
			instructionsQuery.append('personalConnections', true);

			if (instructions?.options?.organization) {
				instructionsQuery.append('organizationId', instructions?.options?.organization);
			}
		}

		if (onlyPersonal) {
			instructionsQuery.append('onlyPersonal', true);
		} else {
			instructionsQuery.append('teamId', instructions?.options?.team);
		}

		await panel.build(
			{
				name: I18n.l('panels.account.create'),
				help: (target && target.closest('imt-panel')?.help) || this.form?.help || config.kb.path,
				src: `${config.api.instructions.path}?${instructionsQuery}`,
				options: {
					oauth: {
						scope: instructions.connectionTypes,
					},
				},
				theme: instructions.theme,
			},
			metadata,
			true,
		);

		return {
			handler: panel,
			dom: panel.panel,
		};
	}
}

window.FormanConnectionManager = ConnectionManager;
